import api from './api';

const tradeService = {
  getActiveTrades: async () => {
    const response = await api.get('/trades/active');
    return response.data;
  },
  
  getTradeHistory: async (page = 1, perPage = 10, context = 'global') => {
    const response = await api.get(`/trades/history?page=${page}&per_page=${perPage}&context=${context}`);
    return response.data;
  },
  
  getPerformanceMetrics: async (context = 'global') => {
    const response = await api.get(`/trades/performance?context=${context}`);
    return response.data;
  },
};

export default tradeService;